/**
 * Permission and role checks aligned with csd-news-service (JWT payload has roles + permissions).
 * Same permissions as news: users with this permission or these roles can publish without approval.
 */
export const PERMISSION_PUBLISH_WITHOUT_APPROVAL = "Publish";
export const CAN_PUBLISH_WITHOUT_APPROVAL = ["admin", "publisher"];

/**
 * @param {object} user - User payload from auth (same shape as news-service decodeToken / stored user).
 *   May have roles (array), permissions (array), or role (string).
 * @returns {boolean} True if user can publish notifications without approval (same logic as news-service).
 */
export function canPublishWithoutApproval(user) {
  if (!user) return false;
  const perms = user.permissions;
  if (Array.isArray(perms)) {
    const hasPermission = perms.some(
      (p) =>
        String(p).toLowerCase() === PERMISSION_PUBLISH_WITHOUT_APPROVAL.toLowerCase() ||
        String(p).toLowerCase() === "publish_without_approval"
    );
    if (hasPermission) return true;
  }
  const role = user.role ?? (Array.isArray(user.roles) ? user.roles[0] : null);
  if (!role) return false;
  return CAN_PUBLISH_WITHOUT_APPROVAL.includes(String(role).toLowerCase());
}
